import type { CoachSessionRow } from '../../customersuccess/framework';

type Props = { sessions?: CoachSessionRow[] };

export function AISuccessCoachPanel({ sessions = [] }: Props) {
  return (
    <div className="space-y-3">
      {sessions.map((s) => (
        <div key={s.title} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-xs font-medium text-brand-600">{s.capability}</p>
          <p className="mt-1 text-sm font-medium">{s.title}</p>
          <p className="mt-1 text-xs text-slate-600 dark:text-slate-400">{s.detail}</p>
        </div>
      ))}
    </div>
  );
}
